import { Dropdown, TextSize, Text, Icon } from '@rhinofi/dvf-shared-ui'
import {
  NavigationLink,
  NavigationLinksContent,
  NavigationSubHref,
  NavigationSubLinksContent,
} from './NavigationLinks.styled'
import { FlexContainer } from '../common/Wrappers/Containers'
import { translate } from '../../intl/i18n'

const developersLinks = [
  {
    id: 'nav-docs',
    title: translate('helpers.api_docs'),
    href: 'https://docs.rhino.fi/get-started/introduction',
  },
  {
    id: 'nav-dev-portal',
    title: translate('helpers.developer_portal'),
    href: 'https://developers.rhino.fi/',
  },
  {
    id: 'nav-supported-chains',
    title: translate('helpers.supported_chains'),
    href: 'https://docs.rhino.fi/general/supported-chains',
  },
]

export const NavigationLinks = () => {
  const title = translate('helpers.developers')

  return (
    <NavigationLinksContent>
      <Dropdown
        triggerType="hover"
        isSecondaryCard
        element={
          <NavigationLink id={`navigation-link-${title}`}>
            <Text className="navigation-link-text" size={TextSize.S} bold>
              {title}
            </Text>
            <Icon id="dropdown" />
          </NavigationLink>
        }
      >
        <NavigationSubLinksContent>
          <FlexContainer $direction="column" $gap="4px" $alignItems="flex-start">
            {developersLinks.map((link) => (
              <NavigationSubHref key={link.id} href={link.href} target="_blank" rel="noopener noreferrer">
                {link.title}
              </NavigationSubHref>
            ))}
          </FlexContainer>
        </NavigationSubLinksContent>
      </Dropdown>
    </NavigationLinksContent>
  )
}
